export default __webpack_public_path__ + "static/media/oneWorld.03309424.jpg";